import { Box, Flex, Image, Text } from "@chakra-ui/react";
import React from "react";
import fbanner from "../../../assets/Home/frames/fbanner.png";
import { Link, useNavigate } from "react-router-dom";

const ILearned = () => {
  const navigate = useNavigate();
  return (
    <Box>
      <Text
        className="oswald-font"
        color={"#3C375F"}
        fontWeight={"bold"}
        fontSize={{ md: 30, base: 20 }}
        textAlign={"center"}
      >
        Today I Learned (TIL)
      </Text>
      <Text
        color={"#7d7d7d"}
        className="lato-font"
        fontWeight={"regular"}
        fontSize={{ md: 16, base: 12 }}
        textAlign={"center"}
      >
        You Learn Something New Every Day What Did You Learn Today?
      </Text>
      <Link to={"/blogs"}>
        <Flex
          m={"auto"}
          mt={5}
          gap={"1.5%"}
          flexDirection={{ md: "row", base: "column" }}
          justifyContent={"space-between"}
        >
          <Image
            src={"https://images.wishfy.io/static/l1.png"}
            w={{ md: "32%", base: "100%" }}
            h={300}
            cursor={"pointer"}
          />
          <Image
            src={"https://images.wishfy.io/static/l2.png"}
            w={{ md: "32%", base: "100%" }}
            h={300}
            cursor={"pointer"}
          />
          <Image
            src={"https://images.wishfy.io/static/l3.png"}
            w={{ md: "32%", base: "100%" }}
            h={300}
            cursor={"pointer"}
          />
        </Flex>
      </Link>
      <Link to={"/blogs"}>
        <Flex
          mt={5}
          flexDirection={{ md: "row", base: "column" }}
          justifyContent={"space-between"}
          gap={"1.5%"}
        >
          <Image
            src={"https://images.wishfy.io/static/l4.png"}
            w={{ md: "60%", base: "100%" }}
            h={300}
            cursor={"pointer"}
          />
          <Image
            src={"https://images.wishfy.io/static/l5.png"}
            w={{ md: "40%", base: "100%" }}
            h={300}
            cursor={"pointer"}
          />
        </Flex>
      </Link>

      {/* art frames */}
      <Box mt={8}>
        <Text
          className="oswald-font"
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={{ md: 30, base: 20 }}
          textAlign={"center"}
        >
          Our Offerings
        </Text>

        <Flex
          w={"100%"}
          alignItems={"center"}
          m={"auto"}
          mt={4}
          gap={4}
          justifyContent={"space-between"}
          flexDirection={{ md: "row", base: "column" }}
        >
          <Image
            src={"https://images.wishfy.io/static/imm.png"}
            onClick={() => navigate("/plantEcommerce")}
            cursor={"pointer"}
            w={{ md: "22%", base: "98%" }}
          />

          <Image
            src={"https://images.wishfy.io/static/f2.png"}
            onClick={() => navigate("/homeDecorAll")}
            cursor={"pointer"}
            w={{ md: "22%", base: "98%" }}
          />
          <Image
            src={"https://images.wishfy.io/static/f32.jpg"}
            onClick={() => navigate("/potsAll")}
            cursor={"pointer"}
            w={{ md: "22%", base: "98%" }}
          />
          <Image
            src={"https://images.wishfy.io/static/f31.jpg"}
            cursor={"pointer"}
            w={{ md: "22%", base: "98%" }}
          />
        </Flex>
      </Box>

      <Image
        src={"https://images.wishfy.io/static/fbanner.png"}
        w={"100%"}
        mt={10}
        cursor={"pointer"}
        onClick={() => navigate("/InvitationSubCat")}
      />
    </Box>
  );
};

export default ILearned;
